import { orgScopedApiClient } from 'api/orgScopedClient'

import { CerebroResourceResponse } from '../types'

import { AgentsQuota } from './agentsTypes'

export const getAgentsQuota = (): Promise<
    CerebroResourceResponse<AgentsQuota>
> => orgScopedApiClient.get('/api/agents/quota/')
